var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useId } from 'react';
import classNames from 'classnames';
import i18n from './i18n/i18n';
export var ToggleSwitch = function (_a) {
    var children = _a.children, className = _a.className, description = _a.description, hideOnOff = _a.hideOnOff, onText = _a.onText, offText = _a.offText, providedId = _a.id, _b = _a.value, value = _b === void 0 ? 'on' : _b, _c = _a.locale, locale = _c === void 0 ? 'nb' : _c, checked = _a.checked, rest = __rest(_a, ["children", "className", "description", "hideOnOff", "onText", "offText", "id", "value", "locale", "checked"]);
    var generatedId = useId();
    var id = providedId !== null && providedId !== void 0 ? providedId : generatedId;
    var text = i18n[locale];
    return (React.createElement("div", { className: classNames('ffe-toggle-switch', { 'ffe-toggle-switch--hide-on-off': hideOnOff }, className) },
        React.createElement("input", __assign({ className: "ffe-toggle-switch__input", type: "checkbox", role: "switch", id: id, value: value, checked: !!checked }, rest)),
        React.createElement("label", { className: "ffe-toggle-switch__label", htmlFor: id },
            React.createElement("span", { className: "ffe-toggle-switch__label-text" },
                children,
                description && (React.createElement("span", { className: "ffe-toggle-switch__label-description" }, description))),
            !hideOnOff && (React.createElement("span", { className: "ffe-toggle-switch__label-off", "aria-hidden": "true" }, offText ? offText : text.OFF)),
            React.createElement("span", { className: "ffe-toggle-switch__switch", "aria-hidden": "true" }),
            !hideOnOff && (React.createElement("span", { className: "ffe-toggle-switch__label-on", id: "test", "aria-hidden": "true" }, onText ? onText : text.ON)))));
};
